import { render, staticRenderFns } from "./ThgOperations.vue?vue&type=template&id=4d2e4737&"
import script from "./ThgOperations.vue?vue&type=script&lang=ts&"
export * from "./ThgOperations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports